<div
    ng-form="burdensAffectedTenureForm"
    data-test-automation="burdens-affected-tenure">
    <table class="table table-hover table-striped">
        <thead>
            <tr class="default">
                <th class="text-nowrap">
                    <i
                        class="nlrp-icon"
                        id="selectAllTenureCheckbox"
                        [ngClass]="{
                            'active': allSelected(),
                            'nlrp-icon-check-box-selected': allSelected(),
                            'nlrp-icon-check-box-unselected': !allSelected()
                            }"
                        (click)="onSelectAll()"
                        data-test-automation="select-all"></i>
                </th>
                <th class="text-nowrap">Plan type</th>
                <th class="text-nowrap">Plan number</th>
                <th class="text-nowrap">Lot number</th>
                <th class="text-nowrap">Title reference</th>
                <th class="text-nowrap">Subject land description</th>
            </tr>
        </thead>
        <tbody>
            @for (option of options; track option) {
                <tr>
                    <td>
                        <i
                            class="nlrp-icon"
                            id="selectTenureCheckbox"
                            [ngClass]="{
                            'active': option.selected,
                            'nlrp-icon-check-box-unselected-error': submitted && !minSelected(),
                            'nlrp-icon-check-box-selected' : option.selected,
                            'nlrp-icon-check-box-unselected': !option.selected
                            }"
                            (click)="option.selected = !option.selected"
                            data-test-automation="select"></i>
                    </td>
                    <td>
                        <span>{{getPlanType(option)}}</span>
                    </td>
                    <td>
                        <span>{{getPlanNumber(option)}}</span>
                    </td>
                    <td>
                        <span>{{getLotNumber(option)}}</span>
                    </td>
                    <td>
                        <span>{{getTitleReference(option)}}</span>
                    </td>
                    <td>
                        <span>{{getSubjectLandDescription(option)}}</span>
                    </td>
                </tr>
            }
        </tbody>
    </table>

    @if (submitted && !minSelected()) {
        <div class="help-block">
            <span>Error!</span>
            <span>Mandatory to select at least 1 burdened affected tenure.</span>
        </div>
    }

    @if (!minSelected()) {
        <input
            type="checkbox"
            name="minSelected"
            class="hidden"
            value="false"
            required />
    }
</div>
